import React from 'react';

const Info = () => (
	<svg viewBox="0 0 44 44" className="icon info">
	<path d="M22,12A10,10,0,1,0,32,22,10,10,0,0,0,22,12Zm.95,15.83H21V19.65h1.92ZM22,18.22a1.1,1.1,0,1,1,1.18-1.08A1.1,1.1,0,0,1,22,18.22Z" />
	</svg>
);

export default Info;
